import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'

const LabeledFormSectionNew = ({
    title,
    subTile,
    children,
    sx,
    titlePros,
    titleRightComponent,
}: {
    children: ReactNode
    title: string
    subTile?: ReactNode
    sx?: SxProps
    titlePros?: Record<string, any>
    titleRightComponent?: ReactNode
}) => {
    return (
        <Container disableGutters sx={sx}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1,
                }}
            >
                <Typography variant={'body2-medium'} {...(titlePros || {})}>
                    {title}
                </Typography>
                {titleRightComponent && titleRightComponent}
            </Box>
            {subTile && (
                <Typography variant="body3" color={`TextSecondary`}>
                    {subTile}
                </Typography>
            )}
            <Container
                disableGutters
                sx={{
                    mt: 2,
                }}
            >
                {children}
            </Container>
        </Container>
    )
}

export default LabeledFormSectionNew
